
import React, { useState, useEffect, } from 'react';
import {
    Typography, Box, Avatar,
    Checkbox,
    Paper,
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';

import ProjectMenu from './ProjectMenu';
import AvatarGroup from './AvatarGroup';

// ==== start Check box =====
const CustomCheckbox = ({ checked, onChange }) => (
    <Checkbox
        checked={checked}
        onChange={onChange}
        icon={
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '4px',
                    border: '1px solid #D0D5DD',
                    backgroundColor: '#E5E8EB',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        }
        checkedIcon={
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '4px',
                    backgroundColor: '#1976d2',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        }
    />
);
// ==== End Check box =====

const ProjectsCardTable = ({ projects, children, index, ...other }) => {

    const [loading, setLoading] = useState(true);
    const [selectedValues, setSelectedValues] = useState([]);

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer);
    }, []);

    const handleCheckboxChange = (name) => {
        setSelectedValues((prev) =>
            prev.includes(name) ? prev.filter((item) => item !== name) : [...prev, name]
        );
    };

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedValues(projects.map((p) => p.name));
        } else {
            setSelectedValues([]);
        }
    };
    return (
        <>
            <div className="row gy-0">
                <Box sx={{ borderRadius: '6px' }}>
                    <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
                        <Table className='shadow-none' sx={{ boxShadow: 'none', borderCollapse: 'separate', backgroundColor:'#f5f6fa', borderSpacing: '0 6px' }}>
                            <TableHead>
                                <TableRow sx={{
                                    backgroundColor: '#DFDFDF',
                                    '& th:first-of-type': { borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' },
                                    '& th:last-of-type': { borderTopRightRadius: '8px', borderBottomRightRadius: '8px' },
                                }}>
                                    <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px' }} padding="checkbox">
                                        <CustomCheckbox
                                            checked={projects.length > 0 && selectedValues.length === projects.length}
                                            onChange={handleSelectAll}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px' }}>#</TableCell>
                                    <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px' }}>Created on</TableCell>
                                    <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px' }}>Name</TableCell>
                                    <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px' }} align='center'>Members</TableCell>
                                    <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px' }}>Budget</TableCell>
                                    <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '4px' }} align='center'>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{backgroundColor:'#fff'}}>
                                {loading
                                    ? [...Array(7)].map((_, i) => (
                                        <TableRow key={i}>
                                            {[...Array(7)].map((_, j) => (
                                                <TableCell key={j}><Skeleton variant="text" /></TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                    : projects.map((project, index) => (
                                        <TableRow key={index} sx={{
                                            borderRadius: '8px',
                                            '& td:first-of-type': { borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' },
                                            '& td:last-of-type': { borderTopRightRadius: '8px', borderBottomRightRadius: '8px' },
                                        }}
                                        component='a' href='/project-details'
                                        
                                        >
                                            <TableCell sx={{ borderBottom: 'none' }} padding="checkbox">
                                                <CustomCheckbox
                                                    checked={selectedValues.includes(project.name)}
                                                    onChange={() => handleCheckboxChange(project.name)}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ fontFamily: 'Manrope', color: '#595959', borderBottom: 'none' }}>{index + 1}</TableCell>
                                            <TableCell sx={{ fontFamily: 'Manrope', color: '#595959', borderBottom: 'none' }}>{project.time}</TableCell>

                                            <TableCell sx={{ borderBottom: 'none' }}>
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    <Avatar sx={{ bgcolor: project.color, width: 30, height: 30, fontSize: 14, fontFamily: 'Manrope' }}>
                                                        {project.initials}
                                                    </Avatar>
                                                    <Box>
                                                        <Typography fontSize={14} fontWeight={500} sx={{ fontFamily: 'Manrope' }}>
                                                            {project.name}
                                                        </Typography>
                                                        <Typography fontSize={12} color="text.secondary" sx={{ fontFamily: 'Manrope' }}>
                                                            {project.desk}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </TableCell>

                                            <TableCell sx={{ borderBottom: 'none' }} align='center'>
                                                <AvatarGroup />
                                            </TableCell>
                                            <TableCell sx={{ fontFamily: 'Manrope', borderBottom: 'none' }}>None</TableCell>
                                            <TableCell align='center' sx={{ fontFamily: 'Manrope', borderBottom: 'none' }}><ProjectMenu /></TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </div>
        </>
    );
};

export default ProjectsCardTable;
